import { render, staticRenderFns } from "./submission-company-panel.vue?vue&type=template&id=60692e50&scoped=true&"
import script from "./submission-company-panel.vue?vue&type=script&lang=ts&"
export * from "./submission-company-panel.vue?vue&type=script&lang=ts&"
import style0 from "./submission-company-panel.vue?vue&type=style&index=0&id=60692e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60692e50",
  null
  
)

export default component.exports